<template>
    <div>
        <div class="right-bottom" v-if="!empty">
            <div
                v-for="(item, index) in list"
                :key="index"
                class="item"
                @click="detail(item)"
            >
                <div class="title">
                    <span style="color: blue; margin-right: 10px;">
                        <!-- [{{ item.releaseTime.split(" ")[0] }}] -->
                        {{ item.type_dictText }}
                    </span>
                    <span style="flex: 1;overflow: hidden; text-overflow: ellipsis;white-space: nowrap;" >{{ item.title }}</span>
                    <div class="time">
                        {{ item.releaseTime }}
                    </div>
                </div>
                
            </div>

            
        </div>
        <div style="margin-top: 50px;margin-bottom: 30px; text-align: center;" v-if="!empty">
            <el-pagination
                layout="prev, pager, next"
                :total="total"
                @current-change="currentPage"
                @prev-click="shang"
                @next-click="xia"
            >
            </el-pagination>
        </div>

        <div v-if="empty">
            <el-empty description="暂无搜索结果"></el-empty>
        </div>
    </div>
</template>

<script>
import { Server } from "@/server";
export default {
    name: 'searchResult',
    data() {
        return {
            release_type: '', // 输入的值

            list: [], // 结果数组

            total: 0, // 共多少条数据

            empty: false, // 是否没有数据
        }
    },
    created() {
        //     console.log('created');
        // console.log(this.$route.query);
        // this.release_type = this.$route.query.value
    },
    mounted() {
        // console.log('mounted');
        // this.search()
    },
    watch: {
        $route(newVal, oldVal) {
            this.release_type = newVal.query.value
            this.search()
        },
        pageNo() {
            this.gettype();
        },
    },
    methods: {
        search () {
            Server.searchResult({condition: this.release_type}).then(res => {
            console.log(res);
            this.list = res.result.records
            this.total = res.result.total
            if(this.total == 0) {
                this.empty = true
            }
        })
        },
        detail(item) {
            console.log(item);
            if (item.type == '1') {
                this.$router.push({
                    path: "/noticetwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '贸促新闻',
                    },
                });
            }
            if (item.type == '2') {
                this.$router.push({
                    path: "/tongzhigonggao",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '通知公告',
                    },
                });
            }
            if (item.type == '3') {
                this.$router.push({
                    path: "/tupianxinwen",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '图片新闻',
                    },
                });
            }
            if (item.type == '4') {
                this.$router.push({
                    path: "/zhuantizhuanlan",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '专题专栏', 
                    },
                });
            }
            if (item.type == 5) {
                this.$router.push({
                    path: "/huizhanxinxi",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '会展信息',
                    },
                });
            }
            if (item.type == 6) {
                this.$router.push({
                    path: "/policytwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '政策法规',
                    },
                });
            }
            if (item.type == 7) {
                this.$router.push({
                    path: "/guojilianluotwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '国际联络',
                    },
                });
            }
            if (item.type == 8) {
                this.$router.push({
                    path: "/fengxianfangkong",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '风险防控',
                    },
                });
            }
            if (item.type == 9) {
                this.$router.push({
                    path: "/guojijingmao",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '国际经贸促进',
                    },
                });
            }
            if (item.type == 10) {
                this.$router.push({
                    path: "/xiangmuduijie",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '项目对接',
                    },
                });
            }
            if (item.type == 11) {
                this.$router.push({
                    path: "/guojihuiketing",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '国际会客厅',
                    },
                });
            }
            if (item.type == 12) {
                this.$router.push({
                    path: "/huiyuanzhijia",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '会员之家',
                    },
                });
            }
            if (item.type == 13) {
                this.$router.push({
                    path: "/jingmaoqiatantwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '经贸洽谈',
                    },
                });
            }
            if (item.type == 14) {
                this.$router.push({
                    path: "/duiwaimaoyitwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '对外贸易',
                    },
                });
            }
            if (item.type == 15) {
                this.$router.push({
                    path: "/kuajingfuwutwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '跨境服务',
                    },
                });
            }
            if (item.type == 16) {
                this.$router.push({
                    path: "/shangshirenzheng",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '商事认证',
                    },
                });
            }
            if (item.type == 17) {
                this.$router.push({
                    path: "/xiangmutuiguang",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '项目推广',
                    },
                });
            }
            if (item.type == 18) {
                this.$router.push({
                    path: "/zhaoshangtouzitwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '招商引资',
                    },
                });
            }
            if (item.type == 19) {
                this.$router.push({
                    path: "/touzicujintwo",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '投资促进',
                    },
                });
            }
            if (item.type == 20) {
                this.$router.push({
                    path: "/jiandangzhuanlan",
                    query: {
                        type: item.type,
                        id: item.id,
                        toPath: "/hometwo",
                        toCTitle: '党务公开',
                    },
                });
            }
        },

        currentPage(page) {
            this.pageNo = page;
        },
        xia() {
            this.pageNo = this.pageNo + 1;
        },
        shang() {
            this.pageNo = this.pageNo - 1;
        },
    }
}
</script>

<style lang="less" scoped>
.router-view {
    background: transparent;
}
.right-bottom {
    padding: 15px 0;
    .item {
        padding: 20px;
        background-color: #cccccc;
        cursor: pointer;
        .title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            font-size: 20px;

            display: flex;
            align-items: center;
        }
        .time {
            margin-left: 20px;
        }
    }
    .item:nth-child(2n) {
        background-color: #ffffff;
    }
    .item:hover {
        opacity: 0.8;
    }
}
</style>